import { ResponseError } from '@nexelem/api';

type JSONResponseError = {
  message?: string;
  error?: {
    description?: string;
  };
};
export const extractResponseErrorMessage = async (error: Error): Promise<string> => {
  if (isResponseError(error)) {
    const json = (await error?.response?.json?.()) as JSONResponseError;
    return json?.message || json?.error?.description || '';
  }

  return '';
};

export const isResponseError = (error: Error): error is ResponseError => error.name === 'ResponseError';
